import script from "./ListItemVessel.vue?vue&type=script&lang=ts&setup=true"
export * from "./ListItemVessel.vue?vue&type=script&lang=ts&setup=true"

import "./ListItemVessel.vue?vue&type=style&index=0&id=1ba09d1c&lang=css"

const __exports__ = script;

export default __exports__